import { ManagerRole } from '../../../../../../hooks/auth/usePermissions';

export default {
  form: {
    title: 'Manager toevoegen',
    first_name: {
      label: 'Voornaam',
      placeholder: 'Walter',
    },
    last_name: {
      label: 'Achternaam',
      placeholder: 'White',
    },
    city: {
      label: 'Stad',
      placeholder: 'Bonn',
    },
    email: {
      label: 'E-mail',
      placeholder: 'thedanger@foodamigos.io',
    },
    roles: {
      label: 'Rol',
      placeholder: 'Rol selecteren',
      // Add-form label for store_admin sent with as_owner; other store admins keep "Admin".
      owner_option: 'Eigenaar',
      options: {
        [ManagerRole.Admin]: 'Admin',
        [ManagerRole.Reseller]: 'Reseller',
        [ManagerRole.SalesManager]: 'Salesmanager',
        [ManagerRole.SalesLeadership]: 'Salesleider',
        [ManagerRole.ContentManager]: 'Contentmanager',
        [ManagerRole.OnboardingManager]: 'Onboardingmanager',
        [ManagerRole.MobileAppsManager]: 'Mobiele-appsmanager',
        [ManagerRole.StoreAdmin]: 'Admin',
        [ManagerRole.StoreEmployee]: 'Medewerker',
        [ManagerRole.StoreOperator]: 'Operator',
        [ManagerRole.SDR]: 'SDR',
      },
      description: {
        [ManagerRole.StoreOperator]:
          '<strong>Operator:</strong> Volledige toegang tot Verkoop, Menu, Topitems, Openingstijden, Cadeaubonnen, Reserveringen en Rapporten voor toegewezen bedrijven.',
        [ManagerRole.StoreEmployee]:
          '<strong>Medewerker:</strong> Beperkte toegang tot alleen Reserveringen en Cadeaubonnen.',
        [ManagerRole.StoreAdmin]:
          '<strong>Eigenaar:</strong> Volledige toegang tot één restaurant, inclusief webshop, belastinginstellingen, marketing en teambeheer. Ontvangt een e-mail met hun inloggegevens. Eén eigenaar per restaurant; andere teamleden kunnen deze niet bewerken of verwijderen.',
      },
    },
    companies: {
      label: 'Bedrijven',
      placeholder: 'Bedrijven selecteren',
      owner_placeholder: 'Selecteer restaurant',
      has_owner: 'Heeft een eigenaar',
    },
  },
  fields: {
    email: 'E-mail',
    name: 'Naam',
    roles: 'Rol',
    created_at: 'Aangemaakt',
    actions: 'Acties',
    companies: 'Bedrijven',
    status: 'Status',
  },
  tags: {
    owner: 'Eigenaar',
  },
  search: {
    placeholder: 'Zoeken op naam of e-mail',
  },
  buttons: {
    add_manager: 'Manager toevoegen',
    actions: 'Acties',
    view_dashboard: 'Dashboard bekijken als deze manager',
    login_as_manager: 'Inloggen als deze manager',
    delete: 'Deze manager verwijderen',
    resend_owner_invite: 'Eigenaarsuitnodiging opnieuw versturen',
  },
  modals: {
    delete_manager: {
      title: 'Weet u zeker dat u manager {{email}} wilt verwijderen?',
    },
    update_manager: {
      title: 'Weet u zeker dat u manager {{email}} wilt bijwerken?',
    },
    resend_owner_invite: {
      title: 'Uitnodiging opnieuw versturen naar {{email}}?',
      description: 'De eigenaar ontvangt per e-mail een nieuw wachtwoord. Het huidige wachtwoord werkt niet meer.',
    },
  },
  toasts: {
    successfully_created_manager: 'Manager succesvol aangemaakt',
    owner_invited: '{{email}} is uitgenodigd als restauranteigenaar en ontvangt de inloggegevens per e-mail.',
    failed_to_load_data: 'Laden mislukt, vernieuw de pagina',
    failed_to_create_manager: 'Manager aanmaken mislukt',
    failed_to_create_magic_link: 'Magic link aanmaken mislukt',
    failed_to_delete_manager: 'Manager verwijderen mislukt',
    manager_got_deleted: 'Manager verwijderd',
    successfully_updated_manager: 'Manager bijgewerkt',
    failed_to_update_manager: 'Manager bijwerken mislukt',
    owner_invite_resent: 'De uitnodiging is opnieuw naar {{email}} verzonden, met een nieuw wachtwoord.',
    owner_invite_resend_cooling_down:
      'De uitnodiging is net opnieuw verzonden. Wacht een paar minuten voordat je hem nogmaals verstuurt.',
    failed_to_resend_owner_invite: 'Uitnodiging opnieuw versturen mislukt',
  },
};
